import { CustomInput } from 'reactstrap';
import Close from '../../images/svg_icons/exit.svg';

import './styles.scss';

const LayerCard = ({ layers, open, onClose, layerSelected, setlayerSelected, poiSelected, setPoiSelected }) => {
    if (!open) return null;
    return (
        <div className="layersCardContainer">
            <div className='header'>
                <img src={Close} alt="close" onClick={onClose} />
            </div>
            <div className='description'>
                Select a geographical boundary to display (you may need to zoom to see it)
            </div>
            <div className='items icon_checkbox_list'>
                {layers.map(item =>
                    <CustomInput
                        key={item.id}
                        type="checkbox"
                        label={item.label}
                        id={item.id}
                        name={item.name}
                        checked={layerSelected === item.id}
                        onChange={(e) => {
                            setlayerSelected(e.target.checked ? item.id : null)
                        }}
                    />)}
            </div>
            <div className='footer'>
                The boundaries on the map are drawn from data provided by Precisely
                Holdings, LLC, the map data provider used by connectMLS. Parcel
                boundaries are supplied by Lightbox Holdings, LP. The map coordinates
                (location) of a listing are determined through Precisely Holdings, LLC
                according to the physical address entered for the listing in connectMLS.
            </div>
            <p></p>
            <div>Select points of interest to display from the list below:</div>
            <div className="items icon_checkbox_list">
              {Object.entries(poiSelected).map(([key,value]) =>
                <CustomInput
                  key={key}
                  type="checkbox"
                  label={value.name}
                  id={key}
                  name={key}
                  checked={value.enabled}
                  onChange={(e) => { setPoiSelected(key,e.target.checked)}}
                />)}
            </div>

        </div>
    )
}

export default LayerCard;
